module.exports = __webpack_public_path__ + "static/img/H40.e5ac073.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/q_and_a/H40.png
// module id = 7jmJ
// module chunks = 0